import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Bars3Icon,
  XMarkIcon,
  UserIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";
import { useAuth } from "../../context/AuthContext";
import NotificationDropdown from "../NotificationDropdown";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { isAuthenticated, user, logout } = useAuth();

  const navigation = [
    { name: "Planning", href: "/", current: location.pathname === "/" },
    {
      name: "Services",
      href: "/services",
      current: location.pathname.includes("/services"),
    },
  ];

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="bg-black text-white shadow-sm border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img
                className="h-16 w-auto"
                src="/assets/icons/nazai-studio-logo.png"
                alt="Nazaï Studio"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                    item.current
                      ? "text-red-500"
                      : "text-white hover:text-red-500"
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            {isAuthenticated ? (
              <div className="flex items-center space-x-2">
                <Link
                  to="/profile"
                  className={`flex items-center space-x-2 p-2 rounded-lg text-white ${location.pathname.includes("/profile")? "bg-gray-800" : ""} hover:text-red-500 hover:bg-gray-800 transition-colors duration-200`}
                >
                  <UserIcon className="h-5 w-5" />
                  <span className="hidden sm:block text-sm">
                    {user?.full_name}
                  </span>
                </Link>
                <NotificationDropdown />
                <button
                  onClick={logout}
                  className="p-2 rounded-lg text-white hover:text-red-500 hover:bg-gray-800 transition-colors duration-200"
                  title="Se déconnecter"
                >
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                  </svg>
                </button>
              </div>
            ) : (
              <Link
                to="/login"
                className="flex items-center space-x-2 p-2 rounded-lg text-white hover:text-red-500 hover:bg-gray-800 transition-colors duration-200"
              >
                <UserIcon className="h-5 w-5" />
                <span className="hidden sm:block text-sm">Se connecter</span>
              </Link>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="p-2 rounded-md text-white hover:text-red-500 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-red-500"
            >
              {isOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-black border-t border-gray-700">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ${
                  item.current
                    ? "text-red-500"
                    : "text-white hover:text-red-500"
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="pt-4 pb-3 border-t border-gray-700">
              <div className="flex items-center px-3 space-y-2 flex-col">
                {isAuthenticated ? (
                  <>
                    <div className="w-full text-center px-3 py-2 text-white text-sm">
                      Bonjour, {user?.full_name}
                    </div>
                    <Link
                      to="/profile"
                      onClick={() => setIsOpen(false)}
                      className={`w-full text-center px-3 py-2 rounded-md text-base font-medium text-white ${location.pathname.includes("/profile") ? "bg-gray-800" : ""} hover:text-red-500 transition-colors duration-200`}
                    >
                      Mon Profil
                    </Link>
                    <button
                      onClick={() => {
                        logout();
                        setIsOpen(false);
                      }}
                      className="w-full text-center px-3 py-2 rounded-md text-base font-medium text-white hover:text-red-500 transition-colors duration-200"
                    >
                      Se déconnecter
                    </button>
                  </>
                ) : (
                  <Link
                    to="/login"
                    onClick={() => setIsOpen(false)}
                    className="w-full text-center px-3 py-2 rounded-md text-base font-medium text-white hover:text-red-500 transition-colors duration-200"
                  >
                    Se connecter
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
